import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerEventosEmpresaPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/eventos-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            for (let i = 0; i < body.length; i++) {
                body[i].fechaprimerreporte = moment(body[i].fechaprimerreporte).format("DD/MM/YYYY HH:mm:ss");
                body[i].fechaultimoreporte = moment(body[i].fechaultimoreporte).format("DD/MM/YYYY HH:mm:ss");
            }
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarNit err");
        console.log(err);
        return { error: true, message: err };
    }
}